import LOGIN from "../symbols/login";
import { HttpRequestGet, HttpRequestPostForLogin } from "../../service";
const adminLoginAction = (payload: any) => ({
  type: LOGIN.LOGIN,
  payload,
});
const adminLoginSuccessAction = (data: any) => ({
  type: LOGIN.LOGIN_SUCCESS,
  payload: {
    data,
    isUserAdmin: true,
  },
});
const adminGetProfileSuccessAction = (data: any) => ({
  type: LOGIN.PROFILE_SUCCESS,
  payload: {
    data,
    isUserAdmin: true,
  },
});
const adminLoginFailureAction = () => ({
  type: LOGIN.LOGIN_FAILURE,
});
const clearadminLoginAction = () => ({
  type: LOGIN.CLEAR_LOGIN,
});

export function adminLogin(Email: string, Password: string) {
  return (dispatch: any) => {
    dispatch(adminLoginAction({ Email, Password }));
    HttpRequestPostForLogin(
      "/admin/login",
      dispatch,
      adminLoginSuccessAction,
      adminLoginFailureAction,
      false,
      {
        Email,
        Password,
      }
    );
  };
}

export function clearAdminLogin() {
  return (dispatch: any) => {
    dispatch(clearadminLoginAction());
  };
}

export function GetProfile() {
  return (dispatch: any) => {
    HttpRequestGet(
      "/portal/profile",
      dispatch,
      adminGetProfileSuccessAction,
      adminLoginFailureAction,
      true
    );
  };
}
